






















































































import Vue from 'vue';
import EventForm from './components/event/EventForm.vue';
import EventURLDialog from './components/event/EventURLDialog.vue';
import { getEvents, deleteEvents } from '@/modules/event/event.service';
import { UserRoles } from '../../modules/auth/auth.model';

export default Vue.extend({
  data() {
    return {
      search: '',
      expanded: [],
      msgSuccess: '',
      msgError: '',
      selectedLines: [],
      tableHeaders: [
        { text: 'Nom',value: 'name' },
        { text: 'Date', value: 'dateString' },
        { text: 'Inscriptions ouvertes', value: 'subscriptionOpenLabel' },
        { text: 'Categorie', value: 'eventCategory.name' },
        { text: 'Site', value:'site.name' },
        { text: 'Actions', value: 'actions' }
        
      ],
      eventList: [] as any[],
      isUser: false,
      isSiteManager: false,
      isAdmin: false,
      confirmDialog: false,
      
    }
  },
  components: {
    EventForm, EventURLDialog
  },
  mounted() {
    if (document && document.title) document.title = 'Evénements LePhare&LaSource';
    //TODO define global variables for right mngmt
    const role = localStorage.getItem('user-role');
    if (role === UserRoles.SITEMNGR.key){
      this.isSiteManager = true;
    }else if (role === UserRoles.ADMIN.key){
      this.isAdmin = true;
    }else if (role === UserRoles.USER.key){
      this.isUser = true;
    }
    this.getEventsList();  
  },
  methods: {
    closeDialog(){
      this.confirmDialog=false;
    },
    manageEvent(id: number){
      this.$router.push('/evenement/gestion?id='+id);
    },
    getEventsList(){
        getEvents().then(res=>{
          if (res.data){
            this.eventList = res.data;
            for (const data of this.eventList){
              const date = new Date(data.date);
              data.date = date.getFullYear()+'-'+(date.getMonth()+1<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+'-'+((date.getDate()<10)?('0'+date.getDate()):date.getDate());
              data.dateString = ((date.getDate()<10)?('0'+date.getDate()):date.getDate())+'/'+(date.getMonth()+1<10?('0'+(date.getMonth()+1)):(date.getMonth()+1))+'/'+date.getFullYear();
              data.subscriptionOpenLabel = data.subscriptionOpen?'Oui':'Non';
            }
          }else if (res.error){
            this.msgError = 'Erreur. Impossible de récupérer les données événements.'
          }
        });
      },
    deleteSelectedEvents(){
      this.msgSuccess = '';
      this.msgError= '';
      deleteEvents(this.selectedLines).then(res=>{
        if(res.data){
          if(res.data.successData.length > 0){
            this.msgSuccess = res.data.successData.length+' évenements ont été supprimés.';
          }
        }
        if(res.error){
          if(res.error.errorData.length > 0){
            this.msgError = res.error.errorData.length+' événements en erreur n\'ont pas été supprimés.';
          }
        }
        this.selectedLines = [];
        this.getEventsList();
        this.confirmDialog= false;
      });
    }
  }
})
